import React, { Component } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { trackInitiateCheckout } from '../MetaPixel';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'href'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  children: React.ReactNode;
  href?: string;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'lg',
  isLoading = false,
  children,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-600 text-white shadow-lg hover:shadow-amber-500/30 focus:ring-amber-500',
    secondary: 'bg-slate-100 hover:bg-slate-200 text-slate-900 border border-slate-300 hover:border-slate-400 focus:ring-slate-500',
    outline: 'bg-transparent border-2 border-slate-300 hover:border-amber-500 text-slate-700 hover:text-amber-500 focus:ring-amber-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const handleClick = (e: any) => {
    // Track Meta Pixel event for primary CTA buttons
    if (variant === 'primary' && href) {
      trackInitiateCheckout();
    }
    // Call original onClick if provided
    if (onClick) {
      onClick(e);
    }
  };
  const Component = href ? motion.a : motion.button;
  const linkProps = href ? {
    href,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <Component whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading} onClick={handleClick} {...linkProps} {...props as any} data-id="element-218">
      {isLoading && <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-219" />}
      {children}
    </Component>;
}